import React, { Component } from 'react';

import classes from './Button.module.css';

class Button extends Component{
  state={
    clicked: false
  }

  clickHandler = () => {
    if(!this.props.disabled){
      this.setState({
        clicked: true
      });
      if(this.props.action){
        window.open(this.props.action, '_blank');
      }
      if(this.props.value){
        this.props.click(this.props.value);
      }
    }
  }

  render(){

    const buttonClasses = [
      // `button-${this.props.type}`,
      classes.Button
    ];

    // if (this.state.clicked){
    //   buttonClasses.push(classes.ButtonClicked)
    // }
    return (
      <button 
        ref={(node) => { this.button = node; }}
        style={this.props.style}
        className={buttonClasses.join(' ')} 
        disabled={this.props.disabled}
        onClick={this.clickHandler}>
        {this.props.image ? <div className={classes.Image}><img src={this.props.image} alt=""/></div> : ''}
        {this.props.imageAlt ? <div className={[classes.Image, classes.ImageAlt].join(' ')}><img src={this.props.imageAlt} alt=""/></div> : ''}
        <span>{this.props.title}</span> 
      </button>
    )
  }
  
}



export default Button;